<template>
  <div class="fixed-plugin">
    <a class="px-3 py-2 fixed-plugin-button text-dark position-fixed" @click="handleToggle" style="z-index: 99999;">
      <i class="py-2 fa fa-cog"></i>
    </a>
    <div class="shadow-lg card overflow-auto">
      <div class="pt-3 pb-0 bg-transparent card-header">
        <div class="" :class="this.$store.state.isRTL ? 'float-end' : 'float-start'">
          <h5 class="mt-3 mb-0">Configuración</h5>
        </div>
        <div class="mt-4" @click="handleToggle" :class="this.$store.state.isRTL ? 'float-start' : 'float-end'">
          <button class="p-0 btn btn-link text-dark fixed-plugin-close-button">
            <i class="fa fa-close"></i>
          </button>
        </div>
        <!-- End Toggle Button -->
      </div>
      <hr class="my-1 horizontal dark" />
      <div class="pt-0 card-body pt-sm-3">
        <!-- Sidebar Backgrounds -->
        <div>
          <h6 class="mb-0">Colores de la barra lateral</h6>
        </div>
        <a href="#" class="switch-trigger background-color">
          <div class="my-2 badge-colors" :class="this.$store.state.isRTL ? 'text-end' : ' text-start'">
            <span class="badge filter bg-gradient-primary active" data-color="primary"
              @click="sidebarColor('primary')"></span>
            <span class="badge filter bg-gradient-dark" data-color="dark" @click="sidebarColor('dark')"></span>
            <span class="badge filter bg-gradient-info" data-color="info" @click="sidebarColor('info')"></span>
            <span class="badge filter bg-gradient-success" data-color="success" @click="sidebarColor('success')"></span>
            <span class="badge filter bg-gradient-warning" data-color="warning" @click="sidebarColor('warning')"></span>
            <span class="badge filter bg-gradient-danger" data-color="danger" @click="sidebarColor('danger')"></span>
          </div>
        </a>
        <!-- Sidenav Type -->
        <div class="mt-3">
          <h6 class="mb-0">Tipo de navegación lateral</h6>
        </div>
        <div class="d-flex gap-2">
          <button id="btn-white" class="btn w-100 px-3 mb-2" :class="this.$store.state.sidebarType === 'bg-white'
            ? 'bg-gradient-success'
            : 'btn-outline-success'
            " @click="sidebarType('bg-white')">
            Claro
          </button>
          <button id="btn-dark" class="btn w-100 px-3 mb-2" :class="this.$store.state.sidebarType === 'bg-default'
            ? 'bg-gradient-success'
            : 'btn-outline-success'
            " @click="sidebarType('bg-default')">
            Oscuro
          </button>
        </div>
        <p class="mt-2 text-sm d-xl-none d-block">
          Puede cambiar el tipo de navegación lateral solo en la vista de escritorio. </p>
        <!-- Navbar Fixed -->
        <!-- Navbar Fixed -->
        <div class="mt-3 d-flex">
          <h6 class="mb-0">Barra de navegación fija</h6>
          <div class="form-check form-switch ps-0 ms-auto my-auto">
            <input class="mt-1 form-check-input" :class="this.$store.state.isRTL ? 'float-end  me-auto' : ' ms-auto'
              " type="checkbox" id="navbarFixed" :checked="this.$store.state.isNavFixed" @click="setNavbarFixed" />
          </div>
        </div>

        <hr class="horizontal dark" />
        <div class="mt-2 d-flex">
          <h6 class="mb-0" :class="this.$store.state.isRTL ? 'ms-2' : ''">
            Tema Claro / Oscuro
          </h6>
          <div class="form-check form-switch ps-0 ms-auto my-auto">
            <input class="form-check-input mt-1 ms-auto" type="checkbox" :checked="this.$store.state.darkMode"
              @click="setDarkMode" />
          </div>
        </div>


        <div class="mt-3">
          <label for="dark-icon" class="form-label">Ícono Oscuro</label>
          <input id="dark-icon" type="file" class="form-control" @change="updateSettings()" />
        </div>
        <!-- Inputs para ícono claro y oscuro -->
        <div class="mt-3">
          <label for="light-icon" class="form-label">Ícono Claro</label>
          <input id="light-icon" type="file" class="form-control" @change="updateSettings()" />
        </div>

        <div v-if="user?.role === '1'">
          <hr class="horizontal dark" />
          <div class="d-flex">
            <h6 class="mb-0  mt-1 " :class="this.$store.state.isRTL ? 'ms-2' : ''">
              Bodegas/Áreas
            </h6>
            <div class="form-check form-switch ps-0 ms-auto my-auto">
              <input class="btn btn-warning btn-sm mt-1 ms-auto mb-0" type="button" value="Ver"
                @click="openModalBodegas" />
            </div>
          </div>

          <hr class="horizontal dark" />
          <div class="d-flex">
            <h6 class="mb-0  mt-1 " :class="this.$store.state.isRTL ? 'ms-2' : ''">
              Tiempo perdido
            </h6>
            <div class="form-check form-switch ps-0 ms-auto my-auto">
              <input class="btn btn-warning btn-sm mt-1 ms-auto mb-0" type="button" value="Ver"
                @click="openModalCategory" />
            </div>
          </div>

          <hr class="horizontal dark" />
          <div class="d-flex">
            <h6 class="mb-0  mt-1 " :class="this.$store.state.isRTL ? 'ms-2' : ''">
              Cuadrilla
            </h6>
            <div class="form-check form-switch ps-0 ms-auto my-auto">
              <input class="btn btn-warning btn-sm mt-1 ms-auto mb-0" type="button" value="Ver" @click="openModalCrews" />
            </div>
          </div>

          <hr class="horizontal dark" v-if="false" />
          <div class="d-flex" v-if="false">
            <h6 class="mb-0  mt-1 " :class="this.$store.state.isRTL ? 'ms-2' : ''">
              Colores
            </h6>
            <div class="form-check form-switch ps-0 ms-auto my-auto">
              <input class="btn btn-warning btn-sm mt-1 ms-auto mb-0" type="button" value="Ver" @click="openModalColors" />
            </div>
          </div>

          <hr class="horizontal dark" />
          <div class="d-flex">
            <h6 class="mb-0  mt-1 " :class="this.$store.state.isRTL ? 'ms-2' : ''">
              Minas
            </h6>
            <div class="form-check form-switch ps-0 ms-auto my-auto">
              <input class="btn btn-warning btn-sm mt-1 ms-auto mb-0" type="button" value="Ver" @click="openModalMines" />
            </div>
          </div>

          <hr class="horizontal dark" />
          <div class="d-flex">
            <h6 class="mb-0  mt-1 " :class="this.$store.state.isRTL ? 'ms-2' : ''">
              Oficios
            </h6>
            <div class="form-check form-switch ps-0 ms-auto my-auto">
              <input class="btn btn-warning btn-sm mt-1 ms-auto mb-0" type="button" value="Ver"
                @click="openModalOficios" />
            </div>
          </div>

          <hr class="horizontal dark" v-if="false" />
          <div class="d-flex mb-6" v-if="false">
            <h6 class="mb-0  mt-1" :class="this.$store.state.isRTL ? 'ms-2' : ''">
              Tallas
            </h6>
            <div class="form-check form-switch ps-0 ms-auto my-auto">
              <input class="btn btn-warning btn-sm mt-1 ms-auto mb-0" type="button" value="Ver" @click="openModalTallas" />
            </div>
          </div>

          <br><br><br>

        </div>

      </div>
    </div>
  </div>

</template>

<script>
import { mapMutations } from "vuex";
import { activateDarkMode, deactivateDarkMode } from "@/assets/js/dark-mode";

import { Modal } from 'bootstrap';

import Swal from 'sweetalert2';


export default {
  name: "configurator",
  props: ["toggle"],
  data() {
    return {
      modalCategory: null,
      modalColors: null,
      modalOficios: null,
      modalBodegas: null,
      user: {}
    }
  },
  methods: {
    ...mapMutations(["navbarMinimize", "sidebarType", "navbarFixed"]),
    handleToggle() {
      const willOpen = !this.$store.state.showConfig;
      if (typeof this.$props.toggle === 'function') {
        this.$props.toggle();
      }
      const body = document.body;
      if (!body) return;
      if (willOpen) {
        body.classList.add('body-no-scroll');
      } else {
        body.classList.remove('body-no-scroll');
      }
    },
    sidebarColor(color = "success") {
      document.querySelector("#sidenav-main").setAttribute("data-color", color);
      this.$store.state.mcolor = `card-background-mask-${color}`;
    },
    sidebarType(type) {
      this.$store.state.sidebarType = type;
    },
    setNavbarFixed() {
      if (
        this.$route.name !== "Profile" ||
        this.$route.name !== "All Projects"
      ) {
        this.$store.state.isNavFixed = !this.$store.state.isNavFixed;
      }
    },
    setDarkMode() {
      if (this.$store.state.darkMode) {
        this.$store.state.darkMode = false;
        this.$store.state.sidebarType = "bg-white";
        deactivateDarkMode();
        return;
      } else {
        this.$store.state.darkMode = true;
        this.$store.state.sidebarType = "bg-default";
        activateDarkMode();
      }
    },
    sidenavTypeOnResize() {
      let white = document.querySelector("#btn-white");
      if (window.innerWidth < 1200) {
        white.classList.add("disabled");
      } else {
        white.classList.remove("disabled");
      }
    },
    openModalBodegas() {
      const modalElement = document.getElementById('ModalBodegas');
      this.modalBodegas = new Modal(modalElement);
      this.modalBodegas.show();
    },
    closeModalBodegas() {
      if (this.modalBodegas) {
        this.modalBodegas.hide(); // Cierra el modal
      }
    },
    openModalCategory() {
      const modalElement = document.getElementById('ModalCategory');
      this.modalCategory = new Modal(modalElement);
      this.modalCategory.show();
    },
    closeModalCategory() {
      if (this.modalCategory) {
        this.modalCategory.hide(); // Cierra el modal
      }
    },
    openModalCrews() {
      const modalElement = document.getElementById('ModalCrews');
      this.modalCrews = new Modal(modalElement);
      this.modalCrews.show();
    },
    closeModalCrews() {
      if (this.modalCrews) {
        this.modalCrews.hide(); // Cierra el modal
      }
    },
    openModalColors() {
      const modalElement = document.getElementById('ModalColors');
      this.modalColors = new Modal(modalElement);
      this.modalColors.show();
    },
    closeModalColors() {
      if (this.modalColors) {
        this.modalColors.hide();
      }
    },
    openModalMines() {
      const modalElement = document.getElementById('ModalMines');
      this.modalMines = new Modal(modalElement);
      this.modalMines.show();
    },
    closeModalMines() {
      if (this.modalMines) {
        this.modalMines.hide();
      }
    },
    openModalOficios() {
      const modalElement = document.getElementById('ModalOficios');
      this.modalOficios = new Modal(modalElement);
      this.modalOficios.show();
    },
    closeModalOficios() {
      if (this.modalOficios) {
        this.modalOficios.hide(); // Cierra el modal
      }
    },
    openModalTallas() {
      const modalElement = document.getElementById('ModalTallas');
      this.modalColors = new Modal(modalElement);
      this.modalColors.show();
    },
    closeModalTallas() {
      if (this.modalColors) {
        this.modalColors.hide(); // Cierra el modal
      }
    },


    async updateSettings() {
      const formData = new FormData();

      // Obtenemos el archivo del ícono claro
      const lightFileInput = document.getElementById("light-icon");
      const lightIcon = lightFileInput?.files[0];

      // Obtenemos el archivo del ícono oscuro
      const darkFileInput = document.getElementById("dark-icon");
      const darkIcon = darkFileInput?.files[0];

      // Añadimos los archivos al formData si existen
      if (lightIcon) {
        formData.append("logo_path", lightIcon);
      }
      if (darkIcon) {
        formData.append("logo_path_dark", darkIcon);
      }

      try {
        // Enviamos los datos al backend mediante el store
        const response = await this.$store.dispatch("settings/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire("Éxito", "El logo ha sido actualizado correctamente.", "success");
          location.reload();
        } else {
          throw new Error("Error al actualizar los íconos.");
        }
      } catch (error) {
        console.error(error);
        await Swal.fire("Error", error.message || "No se pudo actualizar los íconos.", "error");
      }
    },

  },
  mounted() {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      this.user = user;
    } else {
      console.log("No se encontró un usuario en el almacenamiento local.");
    }
  },
  computed: {
    sidenavResponsive() {
      return this.sidenavTypeOnResize;
    },
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
    window.addEventListener("resize", this.sidenavTypeOnResize);
    window.addEventListener("load", this.sidenavTypeOnResize);
  },
};
</script>
